import { render } from "./MembershipPage.vue?vue&type=template&id=95840f60&scoped=true"
import script from "./MembershipPage.vue?vue&type=script&lang=js"
export * from "./MembershipPage.vue?vue&type=script&lang=js"

import "./MembershipPage.vue?vue&type=style&index=0&id=95840f60&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95840f60"]])

export default __exports__